import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

const HlsVideoPlayer = ({ src, poster, videoId, autoPlay }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    let hls;
    const video = videoRef.current;

    const pauseHandler = (e) => {
      if (e.detail !== videoId && !video.paused) {
        video.pause();
      }
    };

    window.addEventListener("video-play", pauseHandler);

    if (video) {
    //   video.muted = true; // REQUIRED for autoplay
      video.playsInline = true;

      // Safari (native HLS)
      if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = src;

        video.onloadedmetadata = () => {
          if (autoPlay) video.play().catch(() => {});
        };
      }
      // Chrome / Firefox
      else if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          if (autoPlay) video.play().catch(() => {});
        });
      }

      video.onplay = () => {
        window.dispatchEvent(
          new CustomEvent("video-play", { detail: videoId })
        );
      };
    }

    return () => {
      window.removeEventListener("video-play", pauseHandler);
      if (hls) hls.destroy();
    };
  }, [src, videoId, autoPlay]);

  return (
    <video
      ref={videoRef}
      controls
    //   muted
      poster={poster}
      style={{ width: "100%", borderRadius: "8px" }}
    />
  );
};

export default HlsVideoPlayer;